<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card class="ma-3 col-sm-6" outlined>
        <v-card-title>Create Outlet</v-card-title>
        <hr class="ma-1">
        <v-col>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-select
                :items="groups"
                label="Group *"
                :rules="groupRules"
                item-text="name"
                item-value="id"
                v-model="selectedGroup"
            ></v-select>
            <v-text-field
                v-model="name"
                :rules="nameRules"
                label="Name *"
                autocomplete="off"
                required
            ></v-text-field>

            <v-text-field
                v-model="description"
                label="Description"
                autocomplete="off"
            ></v-text-field>

            <v-text-field
                v-model="restaurant_id"
                :disabled="!(user === 'superadmin' || user === 'admin')"
                label="Restaurant ID"
                autocomplete="off"
            ></v-text-field>
            <v-text-field
                v-model="gems_group_id"
                :disabled="!(user === 'superadmin' || user === 'admin')"
                label="Gems Group ID"
                autocomplete="off"
            ></v-text-field>

            <div class="pa-3">
              <v-row class="pb-5">
                <v-label class="mt-5">Operation Times</v-label>
                <v-btn
                    class="ml-2"
                    @click="timesDialog = true"
                    small
                >
                  +
                </v-btn>
              </v-row>
              <v-label>Operation:</v-label>
              <v-row class="pa-3">
                <v-input
                    v-for="(ot) in operationTimes"
                    append-icon="close"
                    :key="ot.id"
                    background-color="#F5F5F5"
                    @click:append="removeOperationTime(ot)"
                >
                  {{ convertDayName(ot.day) }} <br> {{ ot.time }}
                </v-input>
              </v-row>
              <v-label>Break:</v-label>
              <v-row class="pa-3">
                <v-input
                    v-for="(bt) in breakTimes"
                    append-icon="close"
                    :key="bt.id"
                    background-color="#F5F5F5"
                    @click:append="removeOperationTime(bt)"
                >
                  {{ convertDayName(bt.day) }} <br> {{ bt.time }}
                </v-input>
              </v-row>
            </div>

            <v-dialog
                v-model="timesDialog"
            >
              <v-card class="pa-3 ma-2">
                <v-radio-group v-model="type" :mandatory="false" row>
                  <v-radio label="Operation" value="operation" @change="changeDay('all')"></v-radio>
                  <v-radio label="Break" value="break" @change="changeDay('break')"></v-radio>
                </v-radio-group>
                <v-select
                    :items="days"
                    :item-text="days.name"
                    label="Day"
                    v-model="day"
                    multiple
                ></v-select>
                <v-text-field
                    v-model="time"
                    label="Time"
                    placeholder="e.g: 1300-1500"
                    autocomplete="off"
                ></v-text-field>
                <v-btn @click="addTime">Add</v-btn>
              </v-card>
            </v-dialog>

            <template>
              <v-file-input
                  accept="image/*"
                  :rules="bgRules"
                  label="Background"
                  id="bgimage"
                  name="background"
                  show-size
                  persistent-hint
                  hint="1200x400px, 2MB"
              ></v-file-input>
            </template>
            <template>
              <v-file-input
                  accept="image/*"
                  label="Logo"
                  :rules="logoRules"
                  id="logoimage"
                  name="logo"
                  show-size
                  persistent-hint
                  hint=".png, max. 540x540px, 300kB"
              ></v-file-input>
            </template>
            <v-text-field
                v-model="mainColor"
                label="Main Color"
                autocomplete="off"
                placeholder="#000000"
                persistent-hint
                hint="leave blank to use default color"
            ></v-text-field>
            <v-col cols="12">
              <header>Layout Font Color</header>

              <v-radio-group class="mt-0" v-model="mainFontColor" row>
                <v-radio
                    label="white"
                    value="white"
                ></v-radio>
                <v-radio
                    label="black"
                    value="black"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12">
              <header>Page Rotation</header>

              <v-radio-group class="mt-0" v-model="pageRotation" row>
                <v-radio
                    label="Normal"
                    :value="0"
                ></v-radio>
                <v-radio
                    label="90 Degrees Counterclockwise"
                    :value="1"
                ></v-radio>
                <v-radio
                    label="90 Degrees Clockwise"
                    :value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4 font-weight-bold"
                @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </v-col>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
    ],
    description: '',
    gems_group_id: '',
    restaurant_id: '',
    selectedGroup: null,
    groupRules: [
      v => !!v || 'Group is required',
    ],
    bgRules: [
      value => !value || value.size < 2000000 || 'Image size should be less than 2 MB!',
    ],
    logoRules: [
      value => !value || value.size < 300000 || 'Image size should be less than 300 kB!',
    ],
    timesDialog: false,
    type: 'operation',
    day: null,
    time: null,
    days: [],
    breakDays: '',
    daySelection: [
      {text: 'Sunday', value: 0},
      {text: 'Monday', value: 1},
      {text: 'Tuesday', value: 2},
      {text: 'Wednesday', value: 3},
      {text: 'Thursday', value: 4},
      {text: 'Friday', value: 5},
      {text: 'Saturday', value: 6}
    ],
    breakTimes: [],
    operationTimes: [],
    slogan: '',
    mainColor: '',
    mainFontColor: 'white',
    pageRotation: 0,
    sloganColor: '',
    breadcrumbsItems: '',
  }),
  props: ['groups', 'user'],
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        let bgimage = document.querySelector('#bgimage');
        let logoimage = document.querySelector('#logoimage');
        let formData = new FormData();

        formData.append('name', this.name);
        formData.append('group_id', this.selectedGroup);
        // nullable
        if (this.description) formData.append('description', this.description);
        if (this.gems_group_id) formData.append('gems_group_id', this.gems_group_id);
        if (this.restaurant_id) formData.append('restaurant_id', this.restaurant_id);
        if (this.slogan) formData.append('slogan', this.slogan);
        if (this.mainColor) formData.append('main_color', this.mainColor);
        if (this.mainFontColor) formData.append('main_font_color', this.mainFontColor);
        if (this.pageRotation) formData.append('page_rotation', this.pageRotation);
        if (this.sloganColor) formData.append('slogan_color', this.sloganColor);
        // image file
        formData.append('background', bgimage.files[0]);
        formData.append('logo', logoimage.files[0]);

        axios.post('/outlet', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          this.operationTimes.forEach(function (ot) {
            axios.post('/operation_times', {
              days: ot.day,
              time: ot.time,
              type: ot.type,
              model_id: response.data.id,
              model_type: 'App\\Outlet'
            })
          });
          this.breakTimes.forEach(function (ot) {
            axios.post('/operation_times', {
              days: ot.day,
              time: ot.time,
              type: ot.type,
              model_id: response.data.id,
              model: 'App\\Outlet'
            })
          });
          window.location.href = '/outlet/' + response.data.id + '/queue/create';
        });
      }
    },
    addTime() {
      let t = {
        day: this.day,
        time: this.time,
        type: this.type,
      };

      t.type === 'operation' ? this.operationTimes.push(t) : this.breakTimes.push(t);

      if (t.type === 'operation') this.breakDays += t.day;
      let bd = '';
      this.operationTimes.forEach(function (t, idx, array) {
        if (idx !== array.length - 1) {
          bd += t.day + ','
        } else {
          bd += t.day
        }
      });
      this.breakDays = bd;

      this.day = null;
      this.time = null;
      this.type = 'operation';
      this.timesDialog = false;
    },
    convertDayName(day) {
      let dayName = '';

      this.daySelection.forEach(function (d) {
        day.forEach(function (x) {
          if (d.value === parseInt(x)) dayName += d.text + ','
        })
      });

      return dayName;
    },
    removeOperationTime(t) {
      // axios to remove operation time
      let type = t.type;
      const i = type === 'operation' ? this.operationTimes.indexOf(t) : this.breakTimes.indexOf(t);
      type === 'operation' ? this.operationTimes.splice(i, 1) : this.breakTimes.splice(i, 1);
    },
    changeDay(type) {
      if (type === 'all') this.days = this.daySelection;
      if (type === 'break') {
        let b = this.breakDays;
        let result = [];
        this.daySelection.forEach(function (d) {
          if (b.includes(d.value)) result.push(d);
        });
        this.days = result;
      }
    },
  },
  beforeMount() {
    this.days = this.daySelection;
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Create Outlet',
      },
    ];
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Outlets/OutletCreate.vue